window.addEventListener("load", (event) => {
  const scrollLinks = document.querySelectorAll(".scroll-link");

  for (const scrollLink of scrollLinks) {
    scrollLink.addEventListener("click", scrollLinkHandler);
  }

  function scrollLinkHandler(e) {
    e.preventDefault();

    const href = this.getAttribute("href");

    // get the correct offset
    const getOffsetTop = (element) => {
      let offsetTop = 0;
      while (element) {
        offsetTop += element.offsetTop;
        element = element.offsetParent;
      }
      return offsetTop;
    };

    // find the target element
    const scrollTarget = document.querySelector(href);

    // the elements offset value
    const offsetTop = getOffsetTop(scrollTarget);

    // current header height value
    const x = getComputedStyle(document.documentElement).getPropertyValue(
      "--header-height"
    );

    // convert to integer
    const headerHeight = parseInt(x);

    // minus header height from the offset
    const totalOffset = offsetTop - headerHeight;

    if (window.matchMedia("(min-width: 768px)").matches) {
      // scroll to element minus the header height
      scroll({
        top: totalOffset,
        behavior: "smooth",
      });
    } else {
      // scroll to element
      scroll({
        top: offsetTop,
        behavior: "smooth",
      });
    }
  }

  if (window.innerWidth < 768) {
    const mobScrollLinks = document.querySelectorAll(".scroll-link");

    for (const mobScrollLink of mobScrollLinks) {
      mobScrollLink.addEventListener("click", mobScrollLinkHandler);
    }

    function mobScrollLinkHandler(e) {
      e.preventDefault();

      // set variables
      var body = document.querySelector("body");
      var button = document.querySelector("#mobile-nav-btn");

      // toggle menu function
      body.classList.toggle("mobile-nav-open");
      button.classList.toggle("toggled");
      document.documentElement.classList.toggle("no-scroll");

      const href = this.getAttribute("href");

      // get the correct offset
      const getOffsetTop = (element) => {
        let offsetTop = 0;
        while (element) {
          offsetTop += element.offsetTop;
          element = element.offsetParent;
        }
        return offsetTop;
      };

      // find the target element
      const scrollTarget = document.querySelector(href);

      // the elements offset value
      const offsetTop = getOffsetTop(scrollTarget);

      // scroll to element minus the header height
      scroll({
        top: offsetTop,
        behavior: "smooth",
      });
    }
  }
});
